import AccesoRepository from '@/services/AccesoRepository'
import SessionService from '@/services/SessionService'
import ConfiguracionRepository from '../../services/ConfiguracionRepository'

export default {
  namespaced: true,
  state: {
    agricultor: {nombreAgricultor: 'Elija Agricultor', idAgricultor: null},
    agricultorList: [],
    // Helper variable to update listaInventario, listaPersonal, and listaFichaAgricola
    // after changing agricultor
    updateAgricultorLists: false,
    listaGrupoExplotacion: {listaParticular:[],listaAgro:[{tipo:0}],listaGanaderia:[{tipo:0}]}
  },
  getters: {
    filteredAgricultorList(state) {
      if (state.agricultor) {
        return state.agricultorList.filter(agricultor => agricultor.agricultor.idAgricultor !== state.agricultor.idAgricultor)
      }
    },

    // Used in router
    isAgricultorSet(state) {
      return state.agricultor.idAgricultor !== null
    },

    isOnlyOperador(state) {
      return state.agricultorList.length === 1 && state.agricultor.nombreAgricultor === SessionService.getNombreOperador()
    },
  },
  mutations: {
    setAgricultor(state, idAgricultor) {
      let index = state.agricultorList.map(agricultor => agricultor.agricultor.idAgricultor).indexOf(idAgricultor)
      state.agricultor = state.agricultorList[index].agricultor
      localStorage.setItem('selectedAgricultor', JSON.stringify(state.agricultor))
    },

    setAgricultorList(state, agricultorList) {
      agricultorList.map(agricultor => {
        if(agricultor.establecimientoList){
          agricultor.establecimientoList.map(est =>{
            est.grupoExplotacionList.map(grupo => {
              grupo.icon = grupo.categoria === 1 ? 'fa-seedling' : 'cow'
              return grupo
            })
          })
        }else{
          agricultor.establecimientoList = []
        }
      })
      state.agricultorList = agricultorList
    },

    clearAgricultor(state) {
      state.agricultor = {nombreAgricultor: 'Elija Agricultor', idAgricultor: null}
      state.agricultorList = []
    },

    restoreAgricultor(state) {
      let selectedAgricultor = localStorage.getItem('selectedAgricultor')

      if (selectedAgricultor) {
        state.agricultor = JSON.parse(selectedAgricultor)
      }
    },

    setUpdateAgricultorLists(state, updateAgricultorLists) {
      state.updateAgricultorLists = updateAgricultorLists
    },

    setListaGrupoExplotacion(state,listaGrupoExplotacion){
      let listaParticular = listaGrupoExplotacion.filter(grupo => grupo.tipo === 2)
      let listaAgro = listaGrupoExplotacion.filter(grupo =>grupo.categoria === 1)
      let listaGanaderia = listaGrupoExplotacion.filter(grupo =>grupo.categoria === 2)

      let listGrupoExpAgrupada = {
        listaParticular : listaParticular,
        listaAgro : listaAgro.length !== 0 ? listaAgro : [{tipo:0}],
        listaGanaderia : listaGanaderia.length !== 0 ? listaGanaderia :[{tipo:0}]
      }
      state.listaGrupoExplotacion = listGrupoExpAgrupada
    }
  },
  actions: {
    async setAgricultor({commit, dispatch}, payload) {
      commit('setAgricultor', payload.idAgricultor)

      if(payload.establecimiento){
        await dispatch('establecimientos/setEstablecimiento', payload.establecimiento, {root:true})

        // await dispatch('session/clear', null, {root: true})
        // await dispatch('temporada/clearTemporadaAgricultor', null, {root:true})
        // await dispatch('temporada/fetchListaTemporadaAgricultor', null, {root:true})
        // await dispatch('temporada/fetchTemporadaActual', null, {root:true})
        // await dispatch('fichas/fetchListaFichaAgricola', null, {root: true})

        commit('setUpdateAgricultorLists', true)
      }
    },

    async fetchAgricultorList({commit, state, dispatch},payload) {
      if (state.agricultorList && state.agricultorList.length > 0) {
        return
      }

      let agricultorList = await AccesoRepository.listaAcceso()
      commit('setAgricultorList', agricultorList)

      if (state.agricultorList.length === 1 && payload && payload === 'restore') {
        await dispatch('setAgricultor', {idAgricultor: state.agricultorList[0].agricultor.idAgricultor})
      }else if(state.agricultorList.length === 1){
        await dispatch('setAgricultor', {idAgricultor: state.agricultorList[0].agricultor.idAgricultor, establecimiento:state.agricultorList[0].establecimientoList[0]})
      }
    },

    clearAgricultor({commit}) {
      commit('clearAgricultor')
    },

    async restoreAgricultor({commit, dispatch}) {
      await dispatch('fetchAgricultorList','restore')

      commit('restoreAgricultor')
    },

    setUpdateAgricultorListsFalse({commit}) {
      commit('setUpdateAgricultorLists', false)
    },

    async fetchListaGrupoExplotacion({commit},idAgricultor){
      let listaGrupoExplotacion = await ConfiguracionRepository.listaGrupoExplotacion(idAgricultor)

      commit('setListaGrupoExplotacion', listaGrupoExplotacion)
    }
  }
}
